import { render, staticRenderFns } from "./CouponsBuy.vue?vue&type=template&id=170f0e1c&scoped=true"
import script from "./CouponsBuy.vue?vue&type=script&lang=js"
export * from "./CouponsBuy.vue?vue&type=script&lang=js"
import style0 from "./CouponsBuy.vue?vue&type=style&index=0&id=170f0e1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170f0e1c",
  null
  
)

export default component.exports